module.exports = __webpack_public_path__ + "static/media/Abdomem.7bb4f295.png";